<template>
  <div class="h-screen flex w-full bg-img" id="page-login">
    <div class="vx-col sm:w-1/3 m-auto self-center login-page full-page">
      <h1 align="center" class="my-4">{{ $t('labels.gmsIq') }}</h1>
      <div class="vx-row m-auto">
        <div class="vx-col w-full">
          <vx-card class="forgotpass-card">
            <div class="vx-card__title mb-5">
              <h2 class="mb-4" align="center">{{$t('labels.heading_forget')}}</h2>
              <p class="pt-4 pb-2" align="center">{{ $t('strings.forgot_account') }}</p>
            </div>
            <form @submit.prevent="checkValidation()" autocomplete="off">
              <div>
                <vs-input
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  :label="$t('labels.email')"
                  v-model="email"
                  class="w-full"
                  v-validate="'required|email'"
                />
                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                <div class="my-5" align="center">
                  <vs-button
                    :disabled="button_loading"
                    id="forgot-password"
                    button="submit"
                    class="vs-component vs-button px-4 md:w-auto md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
                  >{{$t('labels.getOtp')}}</vs-button>
                </div>
                <div class="mb-3 mt-5 forgot-pass" align="center">
                  <div class="vx-row">
                    <div class="vx-col lg: w-1/2">
                      <router-link :to="{name:'login'}">{{$t('labels.backto_login')}}</router-link>
                    </div>
                    <div class="vx-col lg: w-1/2">
                      <router-link
                        :to="{name:'ResetPassword'}"
                      >{{$t('labels.already_have_recovery_password')}}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
const { mapFields } = createHelpers({
  getterType: "getLoginField",
  mutationType: "updateLoginField"
});

export default {
  computed: {
    ...mapFields(["email"])
  },
  mounted() {
    this.setValidationMessage();
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendLink();
        }
      });
    },
    async sendLink() {
      let input = {
        email: this.email
      };
      let response = await this.getHTTPPostResponse(
        "/forgot-password",
        input,
        "#forgot-password",
        true
      );
      if (response) {
        this.$router.push({ name: "ResetPassword" });
      }
    },
    destroyed() {
      this.$store.commit("clearPasswordField", null, { module: "login" });
    }
  }
};
</script>

<style scoped>
button.login-btn {
  background: rgba(var(--vs-primary), 1) !important;
}
button.login-btn.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-primary), 1);
}

button.back-btn {
  background: rgba(var(--vs-maroon), 1) !important;
}
button.back-btn.vs-button-primary.vs-button-filled:hover {
  box-shadow: 0 8px 25px -8px rgba(var(--vs-maroon), 1);
}
h2 ~ p {
  color: #000000;
  font-size: 17px;
}
</style>>

